import { useEffect, FC } from 'react';

import { getUrl } from '../FiltersDesktop/utils';
import { useAppContext } from '../../context/AppContext';

type SlugProps = {
  onChangeRoute: () => void;
};

const Slug: FC<SlugProps> = ({ onChangeRoute }) => {
  const { filters, orderBy, countryPrefix } = useAppContext();

  const state = { filters, orderBy, countryPrefix };

  const setUrl = () => {
    const actualPath = window.location.pathname + window.location.search;
    const newUrl = getUrl(state);

    if (actualPath !== newUrl) {
      window.history.replaceState(null, document.title, newUrl);
      onChangeRoute();
    }
  };

  useEffect(() => {
    if ('requestIdleCallback' in window && window.requestIdleCallback) {
      window.requestIdleCallback(setUrl);
    } else {
      setTimeout(() => {
        setUrl();
      }, 1);
    }
  }, [state]);

  return null;
};

export default Slug;
